import React, { ReactNode } from "react";

interface ModalProps {
  title: string;
  description: string;
  onConfirm: () => void;
  onCancel: () => void;
  isProcessing?: boolean; 
  showCloseButton?: boolean;
  confirmButtonLabel?: string;
  children?: ReactNode;
}

export const Modal: React.FC<ModalProps> = ({
  title,
  description,
  onConfirm,
  onCancel,
  isProcessing,
  showCloseButton,
  confirmButtonLabel = "Confirm", 
  children,
}) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-96 p-6">
        <h2 className="text-lg font-bold mb-4">{title}</h2>
        <p className="text-sm text-gray-600 mb-6">{description}</p>
        {children && <div className="mb-6">{children}</div>}
        <div className="flex justify-end space-x-4">
          {showCloseButton ? (
            <button
              className="px-4 py-2 text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
              onClick={onCancel}
            >
              Close
            </button>
          ) : (
            <>
              {!isProcessing && (
                <button
                  className="px-4 py-2 text-sm text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                  onClick={onCancel}
                >
                  Cancel
                </button>
              )}
              <button
                className={`px-4 py-2 text-sm text-white rounded ${
                  isProcessing ? "bg-primary/60 cursor-not-allowed" : "bg-primary hover:bg-primary/90"
                }`}
                onClick={isProcessing ? undefined : onConfirm}
                disabled={isProcessing}
              >
                {isProcessing ? "Processing..." : confirmButtonLabel}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
